module.exports = __webpack_public_path__ + "img/toolbox.951aa156.svg";